<script>
  import SignupModal from '../../components/shared/SigninModal.svelte'
  import { login } from '../../js-core/conn/auth/auth-main'
  let loginFunc = (email, password) => {
    const loginRes = {}
    const caller = async () => {
      const res = await login(email, password, 'tv-owner');
      loginRes.message = res
      return loginRes
    };
    return caller()
  } 
</script>

<SignupModal 
  signupHeader="Hello, friend"
  signupCallToAction="Enter your info and join us in becoming an Brite Host"
  loginFunc={loginFunc}
  signupUrl="/#/brite-host/auth/sign-up"
/>
